import { formatGlAccountNumber } from "./formatGlAccountNumber"

import type { GlAccount } from "@/graphql/codegen/graphql"

type FormatGlAccountLabelParams = Pick<GlAccount, "number" | "subNumber" | "title">

export const formatGlAccountLabel = (glAccount: FormatGlAccountLabelParams): string =>
  `${formatGlAccountNumber(glAccount)} - ${glAccount.title}`
